<template>
  <div class='page-start'>
    <mdb-container class="col-12 pb-3" fluid>
        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation IT Change Requests</h3>
        <mdb-card-body>
          <mdb-row v-if="this.isCM">
            <mdb-col>
              <mdb-btn class="QuadrusButton" v-on:click="populateCCBOptions" type="submit">Select IT CCB Members</mdb-btn>
            </mdb-col>
          </mdb-row>
          <br><br>

          <mdb-row class="d-flex justify-content-center">
            <mdb-col class="col-6">
              <h4 class="text-center">Filter table by ITCR status</h4>
              <mdb-select class="mb-3" v-model="filterOptions" @getValue="handleToggle($event)" label="Filter ITCRs"/>
            </mdb-col>
          </mdb-row>
          <br>

          <div ref="mainTable">
            <QDataTable id='qcrTable' :rowData="this.itcrData.rowData" :filterWords="this.itcrData.filterWords" :headers="this.itcrData.columns" 
            :btnName="'View'" :hasBtn="true" @use-method='previewITCR' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
          </div>
          <div :class="{'hideSpinner': isSetUp}" class="p-4">
            <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
          </div>
        </mdb-card-body>
      </mdb-card>

      <mdb-modal ref="myModal" size="xl" centered :show="viewCCBTable" @close="viewCCBTable = false" style="z-index: 9999 !important;">
        <mdb-modal-header>
          <mdb-modal-title><p class="h2 grey-text">IT CCB Member Assignment</p></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body style="font-size: 0.9em;" ref="modalBody">
          <div ref="modalAlerts">
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
            Success! The user was added to the CCB group!
            </mdb-alert>
            <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p2" @closeAlert="p2=false" dismiss>
            Success! The user was removed from the CCB group!
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p3" @closeAlert="p3=false" dismiss>
              There was an error submitting changes. Please try again! Error Code P3
            </mdb-alert>
            <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
              Missing Required Fields
            </mdb-alert>
          </div>
          <br>

          <h5>Select groups to assign users</h5>
          <mdb-row>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showSystem" id="showSystem" name="showSystem" label="System Group" 
              @click.native.prevent="handleGroupToggle('System')"/>
              
              <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showFacility" id="showFacility" name="showFacility" label="Facility Group" 
              @click.native.prevent="handleGroupToggle('Facility')"/>
            </mdb-col>
          </mdb-row><br>
          <mdb-col class="d-flex align-items-center justify-content-center">
            <p v-if="!showSystem && !showFacility" class="red-text">At least one group must be selected</p>
          </mdb-col>
          <br>

          <mdb-col v-show="showSystem">
            <h5 class="d-flex align-items-left justify-content-left">CCB Members for the System group</h5>
            <mdb-input class="mt-0" v-model="search1" label="Search" name="searchBar" />
            <mdb-datatable-2 id="userUnassignSystemTable" ref="userUnassignSystemTable" :key="inCcbKey" v-model="systemMemberList" 
            multiselectable @selected="handleSysRemoveSelection" :searching="{value: search1}" />
          </mdb-col>

          <mdb-col v-show="showFacility">
            <h5 class="d-flex align-items-left justify-content-left">CCB Members for the Facility group</h5>
            <mdb-input class="mt-0" v-model="search2" label="Search" />
              <mdb-datatable-2 id="userUnassignFacilityTable" ref="userUnassignFacilityTable" :key="inCcbKey2" v-model="facilityMemberList" 
            multiselectable @selected="handleFacRemoveSelection" :searching="{value: search2}" />

          </mdb-col>
          <mdb-col v-if="showSystem || showFacility">
              <mdb-btn :disabled="!systemCCBMembers.length && !facilityCCBMembers.length" class="QuadrusButton" @click.native="removeFromCCB">Remove Users from CCB group</mdb-btn>
          </mdb-col>
          <br><br>

          <mdb-row>
            <mdb-col>
              <h5 class="d-flex align-items-left justify-content-left">Add CCB users to a group</h5>
              <mdb-input class="mt-0" v-model="search3" label="Search" />
              <mdb-datatable-2 id="userAssignTable" ref="userAssignTable" :key="forCcbKey" v-model="userOptionsForCCB" 
              multiselectable @selected="handleAddSelection" :searching="{value: search3}" />
              <mdb-btn :disabled="!removedCCBUsers.length" class="QuadrusButton" @click.native="addToCCB">Add Users to CCB group</mdb-btn>
            </mdb-col>
          </mdb-row>
        </mdb-modal-body>

        <mdb-modal-footer class="d-flex justify-content-center">
          <mdb-btn color="secondary" @click.native="viewCCBTable = false">Close</mdb-btn>
        </mdb-modal-footer>
      </mdb-modal>

    </mdb-container>
  </div>
</template>
<style>
.roundButton {
  border: none;
  font-size: 1.5em;
  width: 15%; 
  border-radius: 25%;
  padding: .1em;
}
</style>
<script>
import { mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, 
  mdbModalFooter,mdbBtn, mdbDatatable2, mdbInput, mdbAlert } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import { formatDate } from '@/assets/js/formatDate.js';

export default {
	name: 'View-QCRs',
	components: {
    mdbCard,
    mdbCardBody,
    mdbContainer,
    QDataTable,
    mdbRow,
    mdbCol,
    mdbSelect,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbDatatable2,
    mdbInput,
    mdbAlert
  },

  data() {
    return {
      p1: false,
      p2: false,
      p3: false,
      p4: false,

      isSetUp: false,
      isAdmin: false,
      isCM: false,
      isIT: false,
      isOnlyCCB: false,
      
      showClosed: false,
      showPendingSIA: false,
      showPendingCCB: false,
      showPendingWork: false,
      showPendingVerify: false,
      showAll: true,
      showAudited: false,
      showDiscuss: false,
      viewCCBTable: false,

      showSystem: true,
      showFacility: false,

      itcrType: "",

      search1: '',
      search2: '',
      search3: '',
      inCcbKey: 0,
      inCcbKey2: 0,
      forCcbKey: 0,
      systemCCBMembers: [],
      facilityCCBMembers: [],
      removedCCBUsers: [],
      allUsers: [],
      ccbMembers: [],
      
      facilityMemberList: {
        columns: [
          {
            label: 'First Name',
            field: 'firstName',
            sort: true
          },
          {
            label: 'Last Name',
            field: 'lastName',
            sort: true
          },
          {
            label: 'Username',
            field: 'username',
            sort: true
          },
          {
            label: 'Email',
            field: 'email',
          }
        ],
        rows: []
      },
      systemMemberList: {
        columns: [
          {
            label: 'First Name',
            field: 'firstName',
            sort: true
          },
          {
            label: 'Last Name',
            field: 'lastName',
            sort: true
          },
          {
            label: 'Username',
            field: 'username',
            sort: true
          },
          {
            label: 'Email',
            field: 'email',
          }
        ],
        rows: []
      },
      userOptionsForCCB: {
        columns: [
          {
            label: 'First Name',
            field: 'firstName',
            sort: true
          },
          {
            label: 'Last Name',
            field: 'lastName',
            sort: true
          },
          {
            label: 'Username',
            field: 'username',
            sort: true
          },
          {
            label: 'Email',
            field: 'email',
          }
        ],
        rows: []
      },

      filterOptions: [{text: 'Show All', value: 'all', selected: true},{text: 'Show Pending SIA', value: 'sia'},
        {text: 'Show Pending CCB', value: 'ccb'}, {text: 'Show Pending CCB Discussion', value: 'discuss'},{text: 'Show Pending Work', value: 'work'},
        {text: 'Show Pending Verification', value: 'verify'},{text: 'Show Closed', value: 'closed'},{text: 'Show Audited', value: 'audited'}
      ],
      
      stage_SIA: 'SIA',
      stage_CCB: 'IT CCB',
      stage_Work: 'IT Work',
      stage_Verification: 'Verification',
      stage_Completed: 'Closed',
      
      itcrData: {
        columns: [  
          {
            colTitle: 'ITCR Number',
            sortBy: 'ITCRnumber'
          },
          {
            colTitle: 'Stage',
            sortBy: 'state'
          },
          {
            colTitle: 'Date Created',
            sortBy: 'submitDate'
          },
          {
            colTitle: 'Change being implemented',
            sortBy: 'changeDescription'
          },
          {
            colTitle: 'SIA',
            sortBy: 'siaStatus'
          },
          {
            colTitle: 'Work Status',
            sortBy: 'workStatus'
          },
          {
            colTitle: 'Verification Status',
            sortBy: 'verifyStatus'
          },
          {
            colTitle: 'Date Closed',
            sortBy: 'closeDate'
          },
          {
            colTitle: 'Action',
            sortBy: ''
          },
        ],
        rowData: [],
        filterWords: [
          'ITCRnumber',
          'state',
          'submitDate',
          'changeDescription',
          'siaStatus',
          'workStatus',
          'verifyStatus',
          'closeDate'
        ]
      },
      itCcbGroup: ["System"],
      loggedInUserGroups: [],

    }
  },
  
  methods: {
    handleGroupToggle: function(type) {
      if(type == "System") {
        this.showSystem = !this.showSystem;
      } else if(type == "Facility") {
        this.showFacility = !this.showFacility;
      }
      if(!this.itCcbGroup.includes(type) && (type == "System" && this.showSystem) || (type == "Facility" && this.showFacility)) {
        this.itCcbGroup.push(type);
      } else if(this.itCcbGroup.includes(type)) {
        this.itCcbGroup.splice(this.itCcbGroup.indexOf(type), 1);
      }
    },

    // Toggles between showing all QCRs, pending QCRs, open QCRs, and closed QCRs
    handleToggle: function(type) {
      if (type === 'all' && !this.showAll) {
        this.showAll = true;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if(type === 'sia' && !this.showPendingSIA) {
        this.showAll = false;
        this.showPendingSIA = true;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if (type === 'ccb' && !this.showPendingCCB) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = true;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if (type === 'work' && !this.showPendingWork) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = true;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if (type === 'verify' && !this.showPendingVerify) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = true;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if (type === 'closed' && !this.showClosed) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = true;
        this.showAudited = false;
        this.showDiscuss = false;
      } else if (type === 'audited' && !this.showAudited) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = true;
        this.showDiscuss = false;
      } else if (type === 'discuss' && !this.showDiscuss) {
        this.showAll = false;
        this.showPendingSIA = false;
        this.showPendingCCB = false;
        this.showPendingWork = false;
        this.showPendingVerify = false;
        this.showClosed = false;
        this.showAudited = false;
        this.showDiscuss = true;
      } else {
        return;
      }
      this.populateITCRData();
    },

    //===========================================================================================
    //	Method Name	:	populateITCRData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets the QCRs
    //===========================================================================================
    populateITCRData: async function() {
      this.isSetUp = false;
      let token = this.$store.getters.getToken;
      this.itcrData.rowData = [];

      let query = "";
      if(this.showPendingSIA){
        query = "filters[stage][$eq][0]="+ this.stage_SIA;        
      } else if(this.showPendingCCB){
        query = "filters[stage][$eq][0]="+ this.stage_CCB + "&filters[discussionRequired][$eq][1]="+ false;
      } else if(this.showPendingWork){
        query = "filters[stage][$eq][0]="+ this.stage_Work;
      } else if(this.showPendingVerify){
        query = "filters[stage][$eq][0]="+ this.stage_Verification;
      } else if(this.showClosed){
        query = "filters[stage][$eq][0]="+ this.stage_Completed;// + "&filters[auditComplete][$eq][1]="+ false;
      } else if(this.showAudited){
        query = "filters[auditComplete][$eq][0]="+ true;
      } else if(this.showDiscuss){
        query = "filters[discussionRequired][$eq][0]="+ true;
      }
      
      const response = await DatabaseLib.getRequest('strapiDatabase', 'itcrs',token,query);
      response.data.data.forEach(itcr => {
        if((this.isOnlyCCB && this.loggedInUserGroups.includes(itcr.attributes.itcrType)) || !this.isOnlyCCB){
          this.itcrData.rowData.push({
            ITCRnumber: itcr.id,
            state: itcr.attributes.stage,
            submitDate: formatDate(itcr.attributes.submitDate),
            changeDescription: itcr.attributes.changeDescription,
            siaStatus: itcr.attributes.siaDisposition,
            workStatus: itcr.attributes.workDisposition,
            verifyStatus: itcr.attributes.verificationPass,
            closeDate: formatDate(itcr.attributes.closeDate),
          })
        }
      });
      this.isSetUp = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    handleAddSelection: function(event) {
      const activePage = this.$refs.userAssignTable.activePage;
      this.removedCCBUsers = event;
      this.$nextTick(() => {
        if (this.$refs.userAssignTable) {
          this.$refs.userAssignTable.activePage = activePage;
        }
      });
    },
    handleSysRemoveSelection: function(event) {
      const activePage = this.$refs.userUnassignSystemTable.activePage;
      this.systemCCBMembers = event;
      this.$nextTick(() => {
        if (this.$refs.userUnassignSystemTable) {
          this.$refs.userUnassignSystemTable.activePage = activePage;
        }
      });
    },
    handleFacRemoveSelection: function(event) {
      const activePage = this.$refs.userUnassignFacilityTable.activePage;
      this.facilityCCBMembers = event;
      this.$nextTick(() => {
        if (this.$refs.userUnassignFacilityTable) {
          this.$refs.userUnassignFacilityTable.activePage = activePage;
        }
      });
    },

    // Handle adding and removing CCB users
    removeFromCCB: async function () {
      const token = this.$store.getters.getToken;

      try {
        // -----------------------------------
        // Build fast lookup for member IDs
        // -----------------------------------
        const memberMap = new Map(
          this.ccbMembers.map(user => [
            `${user.username}_${user.type}`,
            user.id
          ])
        );

        const usersToRemove = [
          ...this.systemCCBMembers.map(u => ({
            ...u,
            type: "System"
          })),
          ...this.facilityCCBMembers.map(u => ({
            ...u,
            type: "Facility"
          }))
        ];

        // -----------------------------------
        // Delete rows first (parallel)
        // -----------------------------------
        await Promise.all(
          usersToRemove.map(user => {
            const id = memberMap.get(
              `${user.username}_${user.type}`
            );

            if (!id) return Promise.resolve();

            return DatabaseLib.deleteRequest(
              "strapiDatabase",
              "itcr-ccb-members",
              token,
              id
            );
          })
        );

        // -----------------------------------
        // Get unique usernames once
        // -----------------------------------
        const usernames = [
          ...new Set(
            usersToRemove.map(u => u.username)
          )
        ];

        // -----------------------------------
        // Check remaining memberships once
        // -----------------------------------
        const membershipChecks = await Promise.all(
          usernames.map(async username => {
            const query =
              "filters[username][$eq][0]=" +
              username;

            const res = await DatabaseLib.getRequest(
              "strapiDatabase",
              "itcr-ccb-members",
              token,
              query
            );

            return {
              username,
              hasITCCB:
                res.data.data.length > 0
            };
          })
        );

        const membershipMap = new Map(
          membershipChecks.map(x => [
            x.username,
            x.hasITCCB
          ])
        );

        // -----------------------------------
        // Remove from CCB group if needed
        // -----------------------------------
        await Promise.all(
          usernames.map(username => {
            const userObj = usersToRemove.find(
              u => u.username === username
            );

            return this.removeFromCCBGroup(
              userObj,
              membershipMap.get(username)
            );
          })
        );

        // -----------------------------------
        // Update local array once
        // -----------------------------------
        const removeSet = new Set(
          usersToRemove.map(
            u => `${u.username}_${u.type}`
          )
        );

        this.ccbMembers = this.ccbMembers.filter(
          member =>
            !removeSet.has(
              `${member.username}_${member.type}`
            )
        );
      } catch (error) {
        console.log(error);
        this.p3 = true;
      }

      await this.getUserOptions();
      await this.populateCCBOptions();

      this.p2 = true;

      this.$nextTick(() => {
        this.$refs.modalAlerts.scrollIntoView({
          behavior: "smooth"
        });
      });
    },


    // -----------------------------------
    // ADD USERS
    // -----------------------------------
    addToCCB: async function () {
      if (!this.showSystem && !this.showFacility) {
        this.p4 = true;

        this.$nextTick(() => {
          this.$refs.modalAlerts.scrollIntoView({
            behavior: "smooth"
          });
        });

        return;
      }

      const token = this.$store.getters.getToken;

      try {
        // -----------------------------------
        // Get CCB group once
        // -----------------------------------
        const response =
          await DatabaseLib.getRequest(
            "strapiDatabase",
            "groups",
            token,
            "filters[name][$eq][0]=CCB"
          );

        const ccbGroup =
          response.data.data[0].id;

        // -----------------------------------
        // Existing lookup
        // -----------------------------------
        const existing = new Set(
          this.ccbMembers.map(
            u => `${u.username}_${u.type}`
          )
        );

        // -----------------------------------
        // Add users to CCB group only once
        // -----------------------------------
        await Promise.all(
          this.removedCCBUsers.map(user =>
            this.addToCcbGroup(
              user,
              ccbGroup
            )
          )
        );

        // -----------------------------------
        // Insert memberships
        // -----------------------------------
        const requests = [];

        for (const user of this.removedCCBUsers) {
          for (const type of this.itCcbGroup) {
            const key =
              `${user.username}_${type}`;

            if (existing.has(key))
              continue;

            requests.push(
              DatabaseLib.postRequest(
                "strapiDatabase",
                "itcr-ccb-members",
                token,
                {
                  data: {
                    itcrType: type,
                    firstLastName:
                      `${user.firstName} ${user.lastName}`,
                    username:
                      user.username,
                    email: user.email
                  }
                }
              ).then(res => {
                this.ccbMembers.push({
                  id:
                    res.data.data.id,
                  type,
                  firstLastName:
                    `${user.firstName} ${user.lastName}`,
                  email:
                    user.email,
                  username:
                    user.username
                });
              })
            );
          }
        }

        await Promise.all(requests);
      } catch (error) {
        console.log(error);
        this.p3 = true;
      }

      await this.getUserOptions();
      await this.populateCCBOptions();

      this.p1 = true;

      this.$nextTick(() => {
        this.$refs.modalAlerts.scrollIntoView({
          behavior: "smooth"
        });
      });
    },


    // -----------------------------------
    // REMOVE FROM GROUP
    // -----------------------------------
    removeFromCCBGroup: async function (
      userObj,
      hasITCCB
    ) {
      const groups =
        userObj.groups || [];

      const ccbProjects =
        userObj.ccb_projects || [];

      const foundGroup =
        groups.find(
          g => g.name === "CCB"
        );

      if (!foundGroup) return;

      if (
        ccbProjects.length === 0 &&
        !hasITCCB
      ) {
        const token =
          this.$store.getters.getToken;

        await DatabaseLib.putRequest(
          "strapiDatabase",
          "users",
          token,
          userObj.id,
          {
            groups: groups
              .filter(
                g =>
                  g.id !==
                  foundGroup.id
              )
              .map(g => g.id)
          }
        );
      }
    },


    // -----------------------------------
    // ADD TO GROUP
    // -----------------------------------
    addToCcbGroup: async function (
      userObj,
      ccbGroup
    ) {
      const groups =
        userObj.groups || [];
      const alreadyExists =
        groups.some(
          g => g.name === "CCB"
        );

      if (alreadyExists) return;

      const token =
        this.$store.getters.getToken;
      await DatabaseLib.putRequest(
        "strapiDatabase",
        "users",
        token,
        userObj.id,
        {
          groups: groups
            .map(g => g.id)
            .concat(ccbGroup)
        }
      );
    },

    populateCCBOptions: function(){
      this.viewCCBTable = true;
      const usersInSysCcb = [];
      const usersInFacCcb = [];
      const usersNotInCcb = [];
      this.allUsers.forEach(user => {
        const clonedUser = { ...user };
        let foundSys = this.ccbMembers.find(u => u.username === user.username && u.type === 'System');
        let foundFac = this.ccbMembers.find(u => u.username === user.username && u.type === 'Facility');
        if (foundSys !== undefined) {
          usersInSysCcb.push(clonedUser);
        }
        if(foundFac !== undefined) {
          usersInFacCcb.push(clonedUser);
        }
        if(foundSys === undefined || foundFac === undefined){
          usersNotInCcb.push(clonedUser);
        }
      });
      this.facilityMemberList = {
        columns: [...this.facilityMemberList.columns],
        rows: [...usersInFacCcb]
      };
      this.systemMemberList = {
        columns: [...this.systemMemberList.columns],
        rows: [...usersInSysCcb]
      };
      this.userOptionsForCCB = {
        columns: [...this.userOptionsForCCB.columns],
        rows: [...usersNotInCcb]
      };
      this.systemCCBMembers = [];
      this.removedCCBUsers = [];
      this.facilityCCBMembers = [];
      this.inCcbKey++;
      this.forCcbKey++;
      this.inCcbKey2++;
    },

     getUserOptions: async function(){
      let token = this.$store.getters.getToken;	
      let query = "filters[blocked][$eq][0]="+false+"&populate[1]=groups&populate[2]=role";
      let response = '';
      this.allUsers = [];
      try {
        response = await DatabaseLib.getRequest('strapiDatabase','users',token,query);
        for(let c = 0; c < response.data.length; c = c + 1){
          if(response.data[c].role.name != "Administrator"){
            this.allUsers.push(response.data[c]);
          }
        }
      } catch(error) {
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }
    },

    getCCBMembers: async function(){
      let token = this.$store.getters.getToken;
      try{
        const response = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,"");
        response.data.data.forEach(member => {
          this.ccbMembers.push({
            id: member.id,
            type: member.attributes.itcrType,
            firstLastName: member.attributes.firstLastName,
            email: member.attributes.email,
            username: member.attributes.username
          });
        })
      } catch(error) {
        console.log(error);
        return;
      }
    },

     
    //===========================================================================================
    //	Method Name	:	previewITCR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Loads QCR data to be viewed
    //===========================================================================================
    previewITCR: async function(data) {
      this.$router.push({
          name: 'ViewITCR',
          query: {
            id: data.ITCRnumber
          }
        })
    },
   
    //===========================================================================================
    //	Method Name	:	checkGroups
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Determine what groups the user belongs to
    //===========================================================================================
    checkGroups: async function(){
      if (this.$store.getters.getGroups.includes("IT")){
        this.isIT = true;
      }
      if(this.$store.getters.getGroups.includes("CM")){
          this.isCM = true;
        }
      if (this.$store.getters.getRole == "Administrator"){
        this.isAdmin = true;
      }
      if(this.$store.getters.getGroups.includes("CCB") && (!this.isCM && !this.isAdmin && !this.isIT)){
        this.isOnlyCCB = true;
        let token = this.$store.getters.getToken;
        let query = "filters[username][$eq][0]="+ this.$store.getters.getUser;
        let response = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,query);
        this.loggedInUserGroups = response.data.data.map(group => group.attributes.itcrType);
      }
      await this.populateITCRData();
    }, 
  },

  mounted() {
    this.checkGroups();
    this.getUserOptions();
    this.getCCBMembers();
    window.scroll({top: 0, behavior: 'smooth'});
  }
}
</script>
